import { IPlanAdditionalFeesAndChargesDrawerInfo } from '.';
import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';
import { isEmpty } from '@utils/validationUtils';

export const initialValues: IPlanAdditionalFeesAndChargesDrawerInfo = {
  planCurrency: '',
  policyCost: '',
  endorsementCost: '',
  chargesPercentage: '',
  tPAFeesType: 'AMOUNT',
  tPAFeesAmount: '',
  tPAFeesPercentage: '',
  tPAFeesApplicableOn: '',
  minTPA: '',
  maxTPA: '',
};

export const getInputs = (
  values: IPlanAdditionalFeesAndChargesDrawerInfo = initialValues,
  lovs: Record<string, Record<string, string>>,
  externalCode: string,
  planCurrencySymbol: string
): Record<string, DynamicFormInputType> => ({
  planCurrency: {
    name: 'planCurrency',
    title: 'Currency',
    type: FormInputTypes.newselect,
    placeholder: 'Currency',
    value: !isEmpty(values.planCurrency) ? values.planCurrency : '',
    disabled: true,
    required: true,
    hidden: true,
    injectGlobalLov: {
      type: 'currency',
      value: 'Id',
      display: 'Title',
    },
  },
  policyCost: {
    name: 'policyCost',
    title: 'Policy Cost',
    type: FormInputTypes.currency,
    placeholder: 'Policy Cost',
    value: values.policyCost,
    required: true,
    disabled: false,
    minNumber: 0,
    maxDecimalPercision: 3,
    useCurrencySymbol: true,
    currencySymbol: planCurrencySymbol,
  },
  endorsementCost: {
    name: 'endorsementCost',
    title: 'Endorsement Cost',
    type: FormInputTypes.currency,
    placeholder: 'Endorsement Cost',
    value: values.endorsementCost,
    required: true,
    disabled: false,
    minNumber: 0,
    maxDecimalPercision: 3,
    useCurrencySymbol: true,
    currencySymbol: planCurrencySymbol,
  },
  chargesPercentage: {
    name: 'chargesPercentage',
    title: 'Charges Percentage',
    type: FormInputTypes.percentage,
    placeholder: 'Charges Percentage',
    value: values.chargesPercentage,
    required: true,
    disabled: false,
  },
  tPAFeesType: {
    name: 'tPAFeesType',
    title: 'TPA Fees Type',
    type: FormInputTypes.chips,
    placeholder: 'TPA Fees Type',
    value: !isEmpty(values.tPAFeesType) ? values.tPAFeesType : null,
    multiple: false,
    disabled: false,
    required: externalCode === '6',
    hidden: externalCode != '6',
    selectOptions: lovs.tPAFeesType || {},
  },
  tPAFeesAmount: {
    name: 'tPAFeesAmount',
    title: 'TPA Fees Amount',
    type: FormInputTypes.currency,
    placeholder: 'TPA Fees Amount',
    value: values.tPAFeesAmount,
    required: values.tPAFeesType === 'AMOUNT',
    hidden: values.tPAFeesType !== 'AMOUNT',
    disabled: false,
    minNumber: 0,
    maxDecimalPercision: 3,
    useCurrencySymbol: true,
    currencySymbol: planCurrencySymbol,
  },
  tPAFeesPercentage: {
    name: 'tPAFeesPercentage',
    title: 'TPA Fees Percentage',
    type: FormInputTypes.percentage,
    placeholder: 'TPA Fees Percentage',
    value: values.tPAFeesPercentage,
    required: values.tPAFeesType === 'PERCENTAGE',
    hidden: values.tPAFeesType !== 'PERCENTAGE',
    disabled: false,
  },
  tPAFeesApplicableOn: {
    name: 'tPAFeesApplicableOn',
    title: 'TPA Fees ApplicableOn',
    type: FormInputTypes.chips,
    placeholder: 'TPA Fees ApplicableOn',
    value: !isEmpty(values.tPAFeesApplicableOn)
      ? values.tPAFeesApplicableOn
      : '',
    multiple: false,
    disabled: false,
    required: values.tPAFeesType === 'PERCENTAGE',
    hidden: values.tPAFeesType !== 'PERCENTAGE',
    selectOptions: lovs.tPAFeesApplicableOn || {},
  },
  minTPA: {
    name: 'minTPA',
    title: 'Min TPA',
    type: FormInputTypes.currency,
    placeholder: 'Min TPA',
    value: values.minTPA,
    required: values.tPAFeesType === 'PERCENTAGE',
    hidden: values.tPAFeesType !== 'PERCENTAGE',
    disabled: false,
    maxDecimalPercision: 3,
    useCurrencySymbol: true,
    currencySymbol: planCurrencySymbol,
  },
  maxTPA: {
    name: 'maxTPA',
    title: 'Max TPA',
    type: FormInputTypes.currency,
    placeholder: 'Max TPA',
    value: values.maxTPA,
    required: values.tPAFeesType === 'PERCENTAGE',
    hidden: values.tPAFeesType !== 'PERCENTAGE',
    disabled: false,
    maxDecimalPercision: 3,
    useCurrencySymbol: true,
    currencySymbol: planCurrencySymbol,
  },
});
